import { api } from "@/lib/api";
import type { PaginatedResponse } from "@/types/common/api-types";
import type {
  Category,
  CategoryCreate,
  CategoryUpdate,
  CategorySearchParams,
} from "../../types/services/api-types/category-types";

export const categoryApi = {
  async getCategories(
    params: CategorySearchParams = {}
  ): Promise<PaginatedResponse<Category>> {
    const response = await api.get<PaginatedResponse<Category>>(
      "/services/categories",
      {
        params,
      }
    );
    return response.data;
  },

  async getCategory(id: number): Promise<Category> {
    const response = await api.get<Category>(`/services/categories/${id}`);
    return response.data;
  },

  async createCategory(data: CategoryCreate): Promise<Category> {
    const response = await api.post<Category>("/services/categories", data);
    return response.data;
  },

  async updateCategory(id: number, data: CategoryUpdate): Promise<Category> {
    const response = await api.put<Category>(
      `/services/categories/${id}`,
      data
    );
    return response.data;
  },

  async deleteCategory(id: number): Promise<void> {
    await api.delete(`/services/categories/${id}`);
  },
};
